<template>
	<div>
		<router-view v-if="$route.meta.loginFree || (saasInfo && userInfo)"></router-view>
		<iframe v-if="printPDF" ref="print" :src="printPDF" style="position: fixed; left: 100%; top: 0; width: 0; height: 0;"></iframe>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import {SERVER_ADDR} from '@/config.js'

	export default {
		name: 'App',

		data() {
			return {
				printPDF: ''
			}
		},

		computed: {
			...mapState(['session', 'saasInfo', 'userInfo'])
		},

		watch: {
			$route() {
				this.globalDialogDestroy();
			},

			session: {
				handler(val) {
					if (!val) {
						this.$store.commit('setSystemConfig', null);
						this.$store.dispatch('updateSystemConfig');
					}
				},
				immediate: true
			}
		},

		created() {
			document.body.ondrop = function (event) {
				event.preventDefault();
				event.stopPropagation();
			}
			this.session && this.$store.dispatch('updateLoginInfo');
		},

		methods: {
			print(src) {
				clearTimeout(this._printTimer);
				this.printPDF = '';
				let loading = this.$loading({
					message: '数据文件加载中...'
				});
				this.$nextTick(() => {
					this.printPDF = SERVER_ADDR + '/' + src;
					this.$nextTick(() => {
						this.$refs.print.onload = () => {
							loading.$loadOver();
							try {
								this.$refs.print.contentWindow.print();
							} catch(e) {
								window.open(this.printPDF);
							}

							this._printTimer = setTimeout(() => {
								this.printPDF = '';
							}, 30000);
						};
					});
				});
			},
            printBase64(base64Data) {
                clearTimeout(this._printTimer);
                if (this._blobUrl) {
                    URL.revokeObjectURL(this._blobUrl);
                    this._blobUrl = null;
                }
                this.printPDF = '';

                let loading = this.$loading({
                    message: '数据文件加载中...'
                });

                let raw = base64Data;
                if (raw.includes(',')) {
                    raw = raw.split(',')[1];
                }

                let binaryString = atob(raw);
                let length = binaryString.length;
                let uint8Array = new Uint8Array(length);
                for (let i = 0; i < length; i++) {
                    uint8Array[i] = binaryString.charCodeAt(i);
                }

                let blob = new Blob([uint8Array], { type: 'application/pdf' });
                this._blobUrl = URL.createObjectURL(blob);

                this.$nextTick(() => {
                    this.printPDF = this._blobUrl;
                    this.$nextTick(() => {
                        this.$refs.print.onload = () => {
                            loading.$loadOver();
                            try {
                                this.$refs.print.contentWindow.print();
                            } catch(e) {
                                window.open(this._blobUrl);
                            }

                            this._printTimer = setTimeout(() => {
                                this.printPDF = '';
                                if (this._blobUrl) {
                                    URL.revokeObjectURL(this._blobUrl);
                                    this._blobUrl = null;
                                }
                            }, 30000);
                        };
                    });
                });
            }
        }
	}
</script>

<style lang="stylus">
	@import './assets/style/reset';
	@import './assets/style/fonts';

	@media print {
		body .g-page,
		.c-notice,
		.c-message,
		.c-popup-mask,
		.c-dialog-wrapper {
			display: none;
		}

		.print-body {
			display: block !important;
		}
		.print-page {
			box-sizing: border-box;
			overflow: hidden;
			font-size: 10pt;

			&:nth-last-child(n+2) {
				page-break-after: always;
			}

			&[border="0"] {
				table, td {
					border-color: #fff;
				}
			}
			
			table {
				width: 100%;
				max-width: 100%;
				border: .2mm solid #000;

				td {
					vertical-align: middle;
					border: .2mm solid #000;
					padding: 1.5mm;
					word-break: break-all;

					img {
						vertical-align: middle;
					}
				}
			}	
		}
	}
	
	.c-input,
	.c-select,
	.c-datetime {
		box-shadow: inset 0 2px 4px #eee;
	}
	.m-search-item,
	.c-table-body {
		.c-input,
		.c-select,
		.c-datetime {
			box-shadow: none;
		}
	}

	.g-page .g-content {
		background: #F0F2F5 !important;
	}

	.c-button {
		.icon {
			line-height: 1.1;
			font-size: 1.2em;
		}
	}
	
	.c-module-content {
		> .c-title {
			padding: 0 20px;
		}

		> .c-table:nth-child(1) {
			margin-top: -1px;
		}
	}
	
	.c-table-body {
		.c-input {
			height: 30px;
			background: #FFFAAD;
			
			input {
				padding: 0 5px;
				font-size: 13px;
			}

			textarea {
				height: 28px;
				min-height: 28px;
				padding: 4px 5px;
				font-size: 13px;
			}
		}
		
		.c-select {
			height: 30px;
			background: #FFFAAD;
			
			&-main {
				padding-left: 5px;
			}
			
			&-current {
				font-size: 13px;
			}

			&-icon,
			&-clear {
				width: 24px;
				min-width: 24px;
			}
			
			input {
				background: none;
			}
		}

		.c-datetime {
			height: 30px;
			background: #FFFAAD;

			&-icon,
			&-clear {
				width: 24px;
				min-width: 24px;
			}
			&-line {
				width: 26px;
				min-width: 26px;
			}
			
			input {
				font-size: 13px;
			}
		}

		.c-switch {
			display: block;
		}
	}
	
	.c-table table thead tr th {
		padding-left: 5px;
		padding-right: 5px;
	}
	.c-table table tbody tr td {
		padding: 5px;
	}

	.c-table-button-more ul {
		box-shadow: 0 0 10px 0 rgba(0,0,0,.15);

		li {
			font-size: 13px;
		}
	}

	.c-table-button-item .c-table-button-icon {
		display: none;
	}

	.c-form {
		> .c-title {
			box-sizing: border-box;
			width: 100%;
		}
	}

	.c-pagination {
		height: 40px !important;
	}

	.c-message p {
		max-width: 14em !important;
	}

	.c-form {
		.c-title:nth-child(n+2) {
			margin-top: 10px;
		}
	}

	.c-dialog {
		.c-tab-list ul[type=border-tab] {
			background: #FAFAFA;

			li.z-crt {
				background: linear-gradient(0deg, #FFFFFF 40%, #F2FFFC);
			}
		}
	}

	.m-detail {
		&-tag {
			gap: 6px;
			margin-left: 16px;

			label {
				border: 1px solid #bbb;
				border-radius: 2px;
				padding: 0 6px;
				line-height: 22px;
				font-size: 12px;
				color: #666;
			}
		}

		&-form {
			padding: 0;

			.c-detail-content {
				border: none;
			}

			.c-detail-item {
				border-left: none;

				&-label {
					width: 100px;
				}
			}
		}

		&-box {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			gap: 6px;
			padding: 20px;

			.c-title:nth-child(n+2) {
				margin-top: 10px;
			}

			.custom-table {
				width: 100%;

				&.flex-grow {
					min-height: 200px;
				}
			}
		}
	}

	.c-file-media.s-video {
		position: relative;

		&:after {
			content: '';
			position: absolute;
			inset: 0;
			background-image: url('https://ylserver-2025-online.oss-cn-shanghai.aliyuncs.com/app_static/player.png');
			background-size: 60% 60%;
			background-position: center center;
			background-repeat: no-repeat;
		}
	}

	// temp
	.c-table-main table tbody tr td {
		line-height: 21px;
	}
	.c-table-expand-row {
		padding: 0 0 8px;
	}
	.c-table-expand-content {
		box-shadow: 0 3px 6px 0 rgba(0,0,0,.08);
	}
	.c-table-expand-handle {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 15px;

		.c-icon-angle-right:before {
			content: '\e668';
			font-family: 'cms_font' !important;
		}
	}

	.c-select-icon,
	.c-select-clear,
	.c-datetime-icon,
	.c-datetime-clear {
		min-width: 28px;
	}
	.c-datetime-line {
		min-width: 30px;
	}
	// end temp
</style>